import { Entity } from '@/store/shared/entity'
export default class UserAssignment extends Entity<number>{
    assigneeUserId:number;
    assigneeUser:string;
    acceptUserId:number;
    handoverCustomerAndInitialRecipient:Array<string>=new Array<string>() ;
    acceptUser:string;
    customerIdList:Array<DataItem> = [];
    userCustomers:Array<DataItem>;
    acceptUserCustomers:Array<any>;
    isActive:boolean;
    ids:Array<number>;
    lastModificationTime:Date;
}
class DataItem {
    key: number;
    label: string;
    disabled: boolean;
  
    constructor(key = null, label = "") {
      this.key = key;
      this.label = label;
    }
  }